import { Col, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { hazmatDeclarationSchema } from '../../schemas/hazmatDeclarationSchema';
import { PhoneNumber } from '../FormFields/PhoneNumber';
import { ControlButtons } from '../ControlButtons';

export function HazMatDeclaration({
	currDeclaration = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(hazmatDeclarationSchema),
		defaultValues: currDeclaration,
	});
	return (
		<Container className="component">
			<Container className="component mt-5">
				<Row>
					<div className="mb-4">
						<h2 className="mb-4">Declaration</h2>
						<p>
							On behalf of the operation listed on this permit application, I
							certify the information in this report to be true and correct to
							the best of my knowledge. We agree to store and handle all
							regulated chemicals in a safe manner and will maintain appropriate
							safeguards to contain, separate and monitor said chemicals
							responsibly. We as a company, assure that adequate security
							measures have been taken regarding chemicals; that employees have
							had proper training to handle these materials in a safe manner and
							the proper ways to react to emergency situations; that adequate
							emergency labeling and warning signs are posted and maintained;
							that adequate emergency equipment is available and maintained at
							all times; and that disposal of all hazardous material wastes will
							be in an appropriate and legal manner.
						</p>
					</div>
				</Row>
				<Row>
					<Form.Group>
						<Form.Check>
							<Form.Check.Input {...register('agreed')} />
							<Form.Check.Label>
								<strong>
									I hereby certify that the information presented on these forms
									is true and correct to the best of my knowledge, and thereby
									request a Hazardous Materials Permit to be issued for this
									operation.
								</strong>
							</Form.Check.Label>
						</Form.Check>
						<Form.Text className="text-danger">
							{formState.errors.agreed?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} sm="12" md="6">
						<Form.Label>Title</Form.Label>
						<Form.Control type="text" {...register('title')} />
						<Form.Text className="text-danger">
							{formState.errors.title?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} sm="12" md="6">
						<Form.Label>Name</Form.Label>
						<Form.Control type="text" {...register('name')} />
						<Form.Text className="text-danger">
							{formState.errors.name?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} sm="12" md="6">
						<Form.Label>Phone Number</Form.Label>
						<PhoneNumber register={register} />
						<Form.Text className="text-danger">
							{formState.errors.phone?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} sm="12" md="6">
						<Form.Label>Email</Form.Label>
						<Form.Control type="email" {...register('email')}></Form.Control>
						<Form.Text className="text-danger">
							{formState.errors.email?.message}
						</Form.Text>
					</Form.Group>
				</Row>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
				enableLoading={enableLoading}
			/>
		</Container>
	);
}
